const addForumOption = (options, forum, prefix = '') => {
  if (!forum?.id) return;
  options.push({
    id: forum.id,
    slug: forum.slug,
    label: `${prefix}${forum.name}`,
  });
  (forum.subforums || []).forEach((subforum) => {
    addForumOption(options, subforum, `${prefix}  ↳ `);
  });
};

export function collectForumMoveOptions(universeForumsData) {
  if (!universeForumsData) return [];

  const options = [];
  const forumsByType = universeForumsData.forums || {};

  ['important', 'player_platform', 'roleplay', 'hrp'].forEach((type) => {
    (forumsByType[type] || []).forEach((forum) => addForumOption(options, forum));
  });

  (universeForumsData.roleplayCategories || []).forEach((category) => {
    const categoryPrefix = category.name ? `${category.name} › ` : '';
    (category.forums || []).forEach((forum) => addForumOption(options, forum, categoryPrefix));
  });

  (universeForumsData.elseworlds || []).forEach((elseworld) => {
    const elseworldPrefix = elseworld.name ? `${elseworld.name} › ` : '';
    (elseworld.forums || []).forEach((forum) => addForumOption(options, forum, elseworldPrefix));
  });

  return options;
}
